import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TAlbum } from "../../Types";

export const apiCallGetUsersAlbum = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data:
    | TAlbum
    | {
        id: number;
        status: string;
        pic_resized: string;
        pic_blurred: string;
        accepted: string;
        selfie_verified: string;
        is_cover: boolean;
        date_uploaded: string;
      }[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TAlbum>(`user/getUsersAlbums`, {
    userID
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [
        {
          id: -1,
          status: "",
          pic_resized: "",
          pic_blurred: "",
          accepted: "",
          selfie_verified: "",
          is_cover: false,
          date_uploaded: ""
        }
      ],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [
        {
          id: -1,
          status: "",
          pic_resized: "",
          pic_blurred: "",
          accepted: "",
          selfie_verified: "",
          is_cover: false,
          date_uploaded: ""
        }
      ],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
